export const DriverCustomerTypes = {
  IDriverCustomerService: Symbol("IDriverCustomerService"),
};
